
<div class="flex-col justify-start items-stretch w-100" [formGroup]="rowForm">
  <div class="flex-row space-between items-center" >
    <mat-form-field appearance="outline" class="w-50" >
      <mat-label>Type</mat-label>
      <mat-select placeholder="Select Type" formControlName="type" required>
        @for (type of formatTypeArray; track $index; let i = $index) {
          <mat-option [value]="type">
            {{type.name}}
          </mat-option>
        }
      </mat-select>
      @if (rowForm.get('type')?.errors?.required) {
        <mat-error>Selection is required</mat-error>
      }
    </mat-form-field>
    @if (csvSelected) {
      <mat-form-field appearance="outline" class="w-50">
        <mat-label>Delimiter</mat-label>
        <mat-select placeholder="Select Delimiter" formControlName="fieldDelimiter" required>
          @for (fieldDelimiter of fieldDelimiterArray; track fieldDelimiter) {
            <mat-option [value]="fieldDelimiter">
              {{fieldDelimiter | delimiterDisplay}}
            </mat-option>
          }
        </mat-select>
        @if (rowForm.get('fieldDelimiter')?.errors?.required) {
          <mat-error>Selection is required</mat-error>
        }
      </mat-form-field>
    }
  </div>
  @if (formArr.length>0) {
    <div class="pb-2">
      <div class="uppercase pb-2">Row Components</div>
      <hr>
    </div>
    <div formArrayName="components" cdkDropList class="component-list" (cdkDropListDropped)="drop($event)" class="flex-col">
      @for (component of formArr.controls; track component; let i = $index) {
        <div [formGroupName]="i" [style.background]="i%2===0?'':'#F0F0F0'" class="flex-col justify-stretch pt-1" cdkDrag>
          <div class="flex-row space-between items-start pt-2 pb-0 mb-0 px-1">
            <mat-form-field appearance="outline" [class]="(component.get('type')!.value==undefined || component.get('type')!.value?.id==2 || component.get('type')!.value?.id==4)?'w-47':'w-30'" >
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" autocomplete="off" type="text" (mousedown)="$event.stopPropagation()">
            </mat-form-field>
            <mat-form-field appearance="outline" [class]="(component.get('type')!.value==undefined || component.get('type')!.value?.id==2 || component.get('type')!.value?.id==4)?'w-47':'w-30'" >
              <mat-label>Row Component Type</mat-label>
              <mat-select placeholder="Select Type" formControlName="type" required>
                @for (componentType of rowComponentTypes; track $index; let i = $index) {
                  <mat-option [value]="componentType">
                    {{componentType.label}}
                  </mat-option>
                }
              </mat-select>
              @if (formGroup(i).get('type')?.errors?.['required']) {
                <mat-error>Selection is required</mat-error>
              }
            </mat-form-field>
            @if (component.get('type')!.value?.id==1) {
              <mat-form-field appearance="outline" class="w-30">
                <mat-label>Pattern</mat-label>
                <mat-select placeholder="Select Pattern" formControlName="value" required>
                  @for (pattern of rowDateTimePatterns; track pattern) {
                    <mat-option [value]="pattern">
                      {{pattern}}
                    </mat-option>
                  }
                </mat-select>
                @if (formGroup(i).get('value')?.errors?.['required']) {
                  <mat-error>Selection is required</mat-error>
                }
              </mat-form-field>
            }
            @if (component.get('type')!.value?.id==3) {
              <mat-form-field appearance="outline" class="w-30" >
                <mat-label>Text</mat-label>
                <input class="parameterInput" matInput formControlName="value" autocomplete="off" type="text" (mousedown)="$event.stopPropagation()">
                <mat-hint>{{formGroup(i).get('value')!.value?.length}} character(s)</mat-hint>
              </mat-form-field>
            }
            @if (component.get('type')!.value?.id==5) {
              <mat-form-field appearance="outline" class="w-30" >
                <mat-label>Variable</mat-label>
                <mat-select placeholder="Select Variable" formControlName="value" required>
                  @for (variable of availableCustomerVariables(); track $index; let i = $index) {
                    <mat-option [value]="variable.name">
                      {{variable.name}}
                    </mat-option>
                  }
                </mat-select>
                @if (formGroup(i).get('value')?.errors?.['required']) {
                  <mat-error>Selection is required</mat-error>
                }
              </mat-form-field>
            }
            @if (component.get('type')!.value?.id==6) {
              <mat-form-field appearance="outline" class="w-30" >
                <mat-label>Custom Field</mat-label>
                <mat-select placeholder="Select Custom Field" formControlName="value" required>
                  @for (metadataInfo of availableMetadataInfo(); track $index; let i = $index) {
                    <mat-option [value]="metadataInfo.name">
                      {{metadataInfo.name}}
                    </mat-option>
                  }
                </mat-select>
                @if (formGroup(i).get('value')?.errors?.['required']) {
                  <mat-error>Selection is required</mat-error>
                }
              </mat-form-field>
            }
            <div class="w-10 pt-1">
              <button mat-icon-button class="delete-button" (click)="deleteComponent(i)" matTooltip="Delete Component">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
          @if (flSelected) {
            <div class="flex-row justify-start px-1" >
              <mat-form-field  appearance="outline" class="w-20" >
                <mat-label>Field Length</mat-label>
                <input matInput formControlName="fieldLength" autocomplete="off" type="number" min="1" required (mousedown)="$event.stopPropagation()">
                @if (formGroup(i).get('fieldLength')?.errors?.['required']) {
                  <mat-error>Input is required</mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-40" >
                <mat-label>Padding Direction</mat-label>
                <mat-select placeholder="Select Direction" formControlName="paddingDirection">
                  @for (direction of availablePaddingDirections; track direction) {
                    <mat-option [value]="direction">
                      {{direction}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-30" >
                <mat-label>Padding Character</mat-label>
                <input class="parameterInput" matInput formControlName="paddingCharacter" autocomplete="off" type="text" maxlength="1" (mousedown)="$event.stopPropagation()">
              </mat-form-field>
            </div>
          }
        </div>
      }
    </div>
    <hr>
  }
  <div class="flex-row justify-end">
    <a mat-button color="primary" class="uppercase mb-3" (click)="onAddComponentClick()" [disabled]="!canAddComponent">
      Add Component
    </a>
  </div>
  @if (rowPreview.length>0) {
    <span >Preview: <span class="preview">{{rowPreview}}</span></span>
  }
</div>
